import firebase from 'firebase/app';
import { APP_VERSION } from '../components/party/AppConstants';
import { db } from '../firebase/firebase';
import { getVersion } from './client/PartyClient';
import { IPartyForUser, TPartyKey, TUserId } from '../PartyClientResponse';
import { IPartyPreview } from '../Party';

export const getSettings = async (key: string): Promise<any> =>
  (await db.ref('settings').child(key).once('value')).val();

export const onSettingsUpdate = (key: string, callback: (value: any) => void) => {
  const _callback = (data: firebase.database.DataSnapshot) => callback(data.val());
  const ref = db.ref('settings').child(key);
  ref.on('value', _callback);
  return () => ref.off('value', _callback);
};

export const getIdToken = async () => {
  return (await firebase.auth().currentUser?.getIdToken()) || '';
};

const getUsersPartyRef = (key: TPartyKey) => db.ref('users-parties').child(key);

export const getAllParties = async (): Promise<IPartyForUser[]> => {
  return Object.values((await db.ref('users-parties').once('value')).val() || {});
};

export const getParty = async (key: TPartyKey): Promise<IPartyForUser> => {
  return (await getUsersPartyRef(key).once('value')).val();
};

export const onPartyUpdate = (key: TPartyKey, callback: (event: IPartyForUser | null) => void) => {
  const _callback = (data: firebase.database.DataSnapshot) => callback(data.val() as IPartyForUser);
  const ref = getUsersPartyRef(key);
  ref.on('value', _callback);
  return () => ref.off('value', _callback);
};

export const onPartyPreviewsUpdate = (
  callback: (event: Record<string, IPartyPreview> | null) => void
) => {
  const _callback = (data: firebase.database.DataSnapshot) =>
    callback(data.val() as Record<string, IPartyPreview>);
  db.ref('party-previews').on('value', _callback);
  return () => db.ref('party-previews').off('value', _callback);
};

export const sendFeedback = async (uid: TUserId, body: string) => {
  const ref = db.ref('feedback');
  const childRef = ref.push();
  const apiVersion = await getVersion();
  await (
    await childRef
  ).set({
    uid,
    body,
    time: firebase.firestore.Timestamp.now().seconds,
    appVersion: APP_VERSION,
    apiVersion,
  });
};

export const uploadThumbnail = async (uid: TUserId, thumbnail: string) => {
  if (uid) {
    const ref = db.ref('stream-thumbnail').child(uid);
    await ref.set({ thumbnail, time: firebase.firestore.Timestamp.now().seconds });
  }
};

export const onThumbnailUpdate = (uid: TUserId, callback: (thumbnail: string) => void) => {
  if (!uid) {
    return undefined;
  }
  const _callback = (data: firebase.database.DataSnapshot) => {
    const val = data.val() as { thumbnail: string };
    if (val) {
      callback(val.thumbnail);
    }
  };
  const ref = db.ref('stream-thumbnail').child(uid);
  ref.on('value', _callback);
  return () => ref.off('value', _callback);
};

export const onInvitesUpdate = (uid: TUserId, callback: (value: any) => void) => {
  if (!uid) {
    return;
  }
  const _callback = (data: firebase.database.DataSnapshot) => callback(data.val());
  const ref = db.ref(`invites/${uid}`);
  ref.on('value', _callback);
  return () => ref.off('value', _callback);
};
